// src/memo.ts
var memo = (func) => {
  let cache = [];
  return (...args) => {
    let cached = cache.find((c) => c.args.every((arg, i) => arg === args[i]));
    if (cached) {
      return cached.result;
    } else {
      let result = func(...args);
      cache.push({
        args,
        result
      });
      return result;
    }
  };
};
export {
  memo
};
//# sourceMappingURL=index.mjs.map